export const EMAIL_DOCUMENT_MAX_TEXT_LENGTH = 10_000;
export const EMAIL_DOCUMENT_MAX_LABEL_LENGTH = 500;
export const EMAIL_DOCUMENT_MAX_URL_LENGTH = 2048;
export const EMAIL_DOCUMENT_MAX_PADDING = 200;
export const EMAIL_DOCUMENT_MAX_BORDER_RADIUS = 100;
export const EMAIL_DOCUMENT_MAX_BORDER_WIDTH = 20;
export const EMAIL_DOCUMENT_MAX_FONT_SIZE = 96;
export const EMAIL_DOCUMENT_MIN_FONT_SIZE = 8;
export const EMAIL_DOCUMENT_MAX_LINE_HEIGHT = 2;
export const EMAIL_DOCUMENT_MIN_LINE_HEIGHT = 1;
export const EMAIL_DOCUMENT_LINE_HEIGHT_STEP = 0.01;
export const EMAIL_DOCUMENT_CONTENT_INSET_PX = 24;
export const EMAIL_DOCUMENT_MAX_TEXT_MAX_WIDTH_PX =
  600 - 2 * EMAIL_DOCUMENT_CONTENT_INSET_PX;
export const EMAIL_DOCUMENT_MIN_TEXT_MAX_WIDTH_PX = 40;

import { EMAIL_BUILDER_COLOR_DIVIDER } from "./emailBuilderDesignColors";

export const EMAIL_DOCUMENT_ALLOWED_URL_SCHEMES = ["https", "http", "mailto", "tel"] as const;

export const EMAIL_DOCUMENT_DEFAULT_BAND_BORDER_WIDTH = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
} as const;

export const EMAIL_DOCUMENT_DEFAULT_BAND_BORDER_COLOR = EMAIL_BUILDER_COLOR_DIVIDER;
